<template>
    <v-dialog :width="$vuetify.display.mdAndUp ? (!logged ? 'auto' : 400) : '100%'" v-model="isActive">
        <v-card rounded="md" v-if="!logged">
            <div class="close-button">
                <v-btn variant="text" :icon="mdiClose" color="grey" density="compact"
                       @click="isActive = false"></v-btn>
            </div>
            <div class="d-flex align-center ga-3 ma-4 mr-12 mx-md-7 my-md-4">
                <v-icon :icon="mdiInformationOutline" :size="19" color="grey"></v-icon>
                <p class="text-body-1 font-weight-bold">{{$t('eshop::modals.must_login')}}</p>
            </div>
            <v-divider></v-divider>
            <LoginWindow pure></LoginWindow>
        </v-card>
        <v-card rounded="md" v-else>
            <div class="close-button">
                <v-btn variant="text" :icon="mdiClose" color="grey" density="compact"
                       @click="() => {
                           isActive = false;
                           addingNew = false;
                       }"></v-btn>
            </div>
            <v-card-title :class="{
                'pa-10 pb-5': $vuetify.display.mdAndUp,
                'pa-5 pb-5': $vuetify.display.smAndDown
            }" class="pointer-events-none" style="white-space: initial">
                <div v-if="cart">
                    <p class="text-h6 font-weight-bold">{{$t('eshop::modals.save_to_a_list', {length: String(cart.length)})}}</p>
                    <p class="text-tiny-link font-weight-light text-grey-darken-2">{{$t('eshop::modals.save_and_return')}}</p>
                </div>
                <div v-else>
                    <p class="text-h6 font-weight-bold">
                        {{ !addingNew ? $t('eshop::modals.select_list') : $t('eshop::modals.create_a_list') }}</p>
                    <p class="text-tiny-link font-weight-light text-grey-darken-2 text-wrap">
                        <span v-if="product">{{ product.name }}</span>
                    </p>
                </div>
            </v-card-title>
            <v-card-text :class="{
                'pa-10 pt-0': $vuetify.display.mdAndUp,
                'pa-5 pt-0': $vuetify.display.smAndDown
            }">
                <div v-if="!addingNew && shoppingLists">
                    <TransitionGroup name="product-lists" tag="div"
                                     class="position-relative d-flex flex-column ga-1 pb-3">
                        <template v-for="(list, l) in shoppingLists" :key="l">
                            <v-sheet class="pa-1 pl-2 cursor-pointer d-flex flex-row justify-center" :color="newlyAdded.includes(list.id) ? 'green-lighten-3':''" :height="44"
                                     width="100%" border rounded>
                                <motonet-checkbox v-model="checked" :value="list.id" :hide-details="true"
                                                  class="w-auto">
                                    <p class="text-black pl-2 text-tiny-link">{{
                                        list.name
                                    }}</p>
                                </motonet-checkbox>
                                <div class="d-flex justify-end"
                                     @click="() => {
                                        if(checked.includes(list.id)){
                                           let index = checked.indexOf(list.id);
                                           delete checked[index];
                                        }
                                        else
                                            checked.push(list.id)
                                     }"
                                >

                                    <div class="d-flex ga-1 align-center pa-2" v-if="newlyAdded.includes(list.id)">
                                        <v-icon :icon="mdiCheck" :size="16" color="green-darken-2"></v-icon>
                                        <span class="text-tiny-link text-green-darken-2">{{$t('eshop::modals.added')}}</span>
                                    </div>
                                </div>
                            </v-sheet>
                        </template>
                    </TransitionGroup>
                    <v-btn class="ml-n3" variant="text" color="cis-accent-color" @click="addingNew = true">
                        <template v-slot:prepend>
                            <v-icon :size="16" :icon="mdiPlusCircleOutline"></v-icon>
                        </template>
                        <p class="text-tiny-link text-decoration-underline">{{$t('eshop::modals.create_a_list')}}</p>
                    </v-btn>
                    <template v-if="cart && !skipCartButtons">
                        <v-btn block class="mb-4 mt-3" :height="48" color="green" :elevation="0"
                               @click="() => {
                                    isActive = false;
                                    addingNew = false;
                                }">
                            <p class="text-body-1 font-weight-bold">{{$t('eshop::modals.save_and_leave')}}</p>
                        </v-btn>
                        <v-btn block :height="40" variant="outlined" color="grey-lighten-2"
                               @click="saveAndDiscardCart">
                            <p class="text-tiny-link font-weight-bold text-grey-darken-2">{{$t('eshop::modals.save_and_destroy')}}</p>
                        </v-btn>
                    </template>
                </div>
                <div v-else class="d-flex">
                    <v-text-field density="comfortable" v-model="newListName" :hide-details="true"
                                  :placeholder="$t('eshop::modals.enter_name')" variant="outlined"></v-text-field>
                    <v-btn color="cis-accent-color" height="48" :elevation="0" class="ml-n1 text-body-1 px-7"
                           @click="addNewList">
                        {{$t('eshop::modals.create')}}
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script setup lang="ts">
import {computed, inject, ref, watch} from "vue";
import {
    mdiCheck,
    mdiClose, mdiInformationOutline,
    mdiPlusCircleOutline
} from "@mdi/js";
import LoginWindow from "../../../../frontend/motonet/components/LoginWindow.vue";
import {router, usePage} from "@inertiajs/vue3";
import axios from "axios";
import MotonetCheckbox from "./MotonetCheckbox.vue";

const isActive = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
const addingNew = ref(false);
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
    modelValue: Boolean,
    cart: Array,
    skipCartButtons: Boolean,
    product: Object
})
const route = inject('route');
const checked = ref([]);
const logged = computed(() => {
    return !!usePage().props.customer?.id
})
const saveAndDiscardCart = () => {
    router.post(route('order.removeItems'));
}
const newlyAdded = ref([]);
const shoppingLists = ref(null);
const newListName = ref('');
const loaded = ref(false);
const addNewList = () => {
    if (newListName.value != '') {
        axios.post(route('shoppingLists.add-list', {name: newListName.value})).then((response) => {
            shoppingLists.value = response.data.shoppingLists;
            addingNew.value = false;
            newListName.value = '';
        })
    } else
        addingNew.value = false;
}

const products = computed(() => {
    return props.product?.id ?? JSON.stringify(props.cart.map((val) => val.products.id));
})

watch(isActive, (now) => {
    if (now)
        axios.get(route('shoppingLists.get-lists'), {
            params: {product: products.value}
        }).then((response) => {
            shoppingLists.value = response.data.shoppingLists;
            checked.value = response.data.selectedLists;
            newlyAdded.value = [];
            setTimeout(() => loaded.value = true, 200);
            if (shoppingLists.value.length === 0)
                addingNew.value = true;
        });
});

watch(() => [...checked.value], (now, before) => {
    now.forEach((item) => {
        if (!before.includes(item) && item !== undefined && loaded.value) {
            axios.post(route('shoppingLists.add-product', {
                list: item,
                product: products.value
            }), {product: products.value}).then((response) => {
                newlyAdded.value.push(item);
                shoppingLists.value = response.data.shoppingLists;
                checked.value = response.data.selectedLists;
            })
        }
    })
    before.forEach((item) => {
        if (!now.includes(item) && item !== undefined && loaded.value) {
            axios.delete(route('shoppingLists.remove-product', {list: item, product: products.value}), {
                params: {product: products.value}
            }).then((response) => {
                newlyAdded.value = [];
                shoppingLists.value = response.data.shoppingLists;
                checked.value = response.data.selectedLists;
            })
        }
    })
});
</script>
<style scoped lang="scss">
.close-button {
    position: absolute;
    top: 14px;
    right: 14px;
}

.product-lists-move,
.product-lists-enter-active,
.product-lists-leave-active {
    transition: all 0.3s ease-in-out;
}

.product-lists-enter-from,
.product-lists-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}

.editbox {
    position: absolute;
    left: 40px;


    div {
        padding: 4px;
        padding-left: 4px !important;
        padding-right: 6px;
    }
}
</style>
<style lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'sass:map';
.product-list-edit-input {
    width: 170px;

    input {
        padding: 7px;
        margin-bottom: -3px;
        outline: 1px solid map.get($grey, 'lighten-2');
        font-size: map.get($typography, 'tiny-link', 'size') !important;
    }
}

.pointer-events-none {
    pointer-events: none;
}
</style>
